import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "invite-page my-scroller"
};
const _hoisted_2 = {
  class: "data-cards"
};
const _hoisted_3 = {
  class: "card card-amount"
};
const _hoisted_4 = {
  class: "amount-content"
};
const _hoisted_5 = {
  class: "money"
};
const _hoisted_6 = {
  class: "card data-summary"
};
const _hoisted_7 = {
  class: "summary-item"
};
const _hoisted_8 = {
  class: "value"
};
const _hoisted_9 = {
  class: "summary-item"
};
const _hoisted_10 = {
  class: "value"
};
const _hoisted_11 = {
  class: "summary-item"
};
const _hoisted_12 = {
  class: "value highlight"
};
const _hoisted_13 = {
  class: "summary-item"
};
const _hoisted_14 = {
  class: "value"
};
const _hoisted_15 = {
  class: "card card-explain"
};
const _hoisted_16 = {
  class: "card-title explain-card-title"
};
const _hoisted_17 = {
  class: "title-right"
};
const _hoisted_18 = {
  class: "explain-content"
};
const _hoisted_19 = {
  class: "card card-rebate"
};
const _hoisted_20 = {
  class: "amount-text"
};
const _hoisted_21 = {
  class: "amount-text highlight"
};
const _hoisted_22 = {
  class: "pagination-container"
};
const _hoisted_23 = {
  class: "card card-rebate card-withdraw"
};
const _hoisted_24 = {
  class: "amount-text"
};
const _hoisted_25 = {
  class: "amount-text"
};
const _hoisted_26 = {
  class: "pagination-container"
};
const _hoisted_27 = {
  class: "amount-tip"
};
const _hoisted_28 = {
  class: "dialog-footer"
};
const _hoisted_29 = {
  class: "dialog-footer"
};
import { ref, reactive, computed } from 'vue';
import { getWithdrawList, getProfitList, getMemberInfo, registerInviteCreateInvite, distAddWithdraw, distAddMember } from '@/request/index';
import inviteCard from './inviteCard.vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { useRouter } from 'vue-router';
// 用户分佣记录
const MAX_WITHDRAW_AMOUNT = 2000;
// 添加银行卡校验函数
export default /*@__PURE__*/_defineComponent({
  __name: 'invitePage',
  setup(__props) {
    var _userInfo$value;
    const bankOptions = ref([{
      name: "中国工商银行",
      abbreviation: "ICBC",
      type: "大型国有银行",
      features: "业务广泛，在公司金融、个人金融、金融市场等多领域实力强，网上银行和手机银行功能齐全"
    }, {
      name: "中国农业银行",
      abbreviation: "ABC",
      type: "大型国有银行",
      features: "农村金融领域根基深厚，支持农业发展、服务农村经济、助力乡村振兴，城乡网点多"
    }, {
      name: "中国银行",
      abbreviation: "BOC",
      type: "大型国有银行",
      features: "国际化程度高，外汇业务、国际结算有优势，海外分支机构和代理行网络广"
    }, {
      name: "中国建设银行",
      abbreviation: "CCB",
      type: "大型国有银行",
      features: "在基本建设贷款、住房金融等领域优势明显，拓展多元化金融服务"
    }, {
      name: "交通银行",
      abbreviation: "BCM",
      type: "大型国有银行",
      features: "综合金融服务有特色，推进金融创新，拓展多元业务领域"
    }, {
      name: "中国邮政储蓄银行",
      abbreviation: "PSBC",
      type: "大型国有银行",
      features: "依托邮政网络，网点遍布城乡尤其是农村偏远地区，服务大众基础金融需求"
    }, {
      name: "招商银行",
      abbreviation: "CMB",
      type: "股份制商业银行",
      features: "零售金融业务突出，信用卡、理财、私人银行服务口碑好，注重金融科技创新"
    }, {
      name: "兴业银行",
      abbreviation: "CIB",
      type: "股份制商业银行",
      features: "绿色金融、同业金融影响力强，金融创新积极，理财产品丰富"
    }, {
      name: "中信银行",
      abbreviation: "CITIC",
      type: "股份制商业银行",
      features: "涵盖多领域业务，综合金融服务有优势，信用卡业务发展好"
    }, {
      name: "浦发银行",
      abbreviation: "SPDB",
      type: "股份制商业银行",
      features: "金融创新、企业金融服务突出，探索数字化服务模式"
    }, {
      name: "民生银行",
      abbreviation: "CMBC",
      type: "股份制商业银行",
      features: "服务中小企业和民营企业，小微金融、社区金融有创新"
    }, {
      name: "北京银行",
      abbreviation: "BOB",
      type: "城市商业银行",
      features: "有较强区域影响力，支持首都经济社会发展，积极推进创新"
    }, {
      name: "平安银行",
      abbreviation: "PAB",
      type: "股份制商业银行",
      features: "综合金融服务能力较强，在零售业务方面有诸多特色产品，例如信用卡、消费贷款等业务发展良好，重视金融科技应用，通过数字化手段提升服务效率与客户体验，并且在企业金融领域也积极拓展，为众多企业提供多样化的金融解决方案。"
    }]);
    const router = useRouter();
    let userInfo = computed(() => {
      return JSON.parse(localStorage.getItem('userInfo'));
    });
    let bindWeChat = () => {
      router.push('/user-center?operate=bindWechat');
    };
    const commissionList = ref([]);
    const currentPage1 = ref(1);
    const pageSize1 = ref(10);
    const total1 = ref(0); // 替换为实际的总数据量
    const handleSizeChange1 = val => {
      pageSize1.value = val;
      // 这里调用获取数据的方法
      getProfitListFn();
    };
    const handleCurrentChange1 = val => {
      currentPage1.value = val;
      // 这里调用获取数据的方法
      getProfitListFn();
    };
    let getProfitListFn = () => {
      getProfitList({
        page: currentPage1.value,
        size: pageSize1.value
      }).then(res => {
        let {
          code,
          data
        } = res.data;
        if (code != 200) return;
        commissionList.value = data.list;
        total1.value = data.total;
      });
    };
    getProfitListFn();
    // 用户提现记录
    const withdrawList = ref([]);
    const currentPage2 = ref(1);
    const pageSize2 = ref(10);
    const total2 = ref(0); // 替换为实际的总数据量
    const handleSizeChange2 = val => {
      pageSize2.value = val;
      // 这里调用获取数据的方法
      getWithdrawListFn();
    };
    const handleCurrentChange2 = val => {
      currentPage2.value = val;
      // 这里调用获取数据的方法
      getWithdrawListFn();
    };
    let getWithdrawListFn = () => {
      getWithdrawList({
        page: currentPage2.value,
        size: pageSize2.value
      }).then(res => {
        let {
          code,
          data
        } = res.data;
        if (code != 200) return;
        withdrawList.value = data.list;
        total2.value = data.total;
      });
    };
    getWithdrawListFn();
    // 用户分佣信息
    const commissionData = ref(null);
    let getMemberInfoFn = () => {
      getMemberInfo().then(res => {
        var _data$withdrawLimit;
        let {
          code,
          data
        } = res.data;
        if (code != 200) return;
        commissionData.value = data;
        if (data !== null && data !== void 0 && (_data$withdrawLimit = data.withdrawLimit) !== null && _data$withdrawLimit !== void 0 && _data$withdrawLimit.withdrawLimit) MIN_WITHDRAW_AMOUNT.value = data.withdrawLimit.withdrawLimit;
      });
    };
    getMemberInfoFn();
    // 获取邀请链接
    let inviteShow = ref(false);
    let inviteData = ref(null);
    let getRegisterInviteCreateInvite = async () => {
      let res = await registerInviteCreateInvite();
      let {
        code,
        data
      } = res.data;
      inviteData.value = data;
      inviteShow.value = true;
    };
    // 添加提现相关的响应式数据
    const withdrawDialogVisible = ref(false);
    const withdrawFormRef = ref();
    const withdrawForm = ref({
      memberUsername: '',
      withdrawAmount: undefined,
      paymentType: 'BANK',
      openid: ((_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.openid) || '',
      bankNo: '',
      bankName: '',
      realName: '',
      bankBranchName: ''
    });
    // 添加最小最大提现金额常量
    const MIN_WITHDRAW_AMOUNT = ref(100);
    const validateBankCard = cardNo => {
      // 清理输入值
      cardNo = cardNo.replace(/\s/g, '');
      // 检查是否为纯数字且长度在16-19之间
      if (!/^\d{16,19}$/.test(cardNo)) {
        return false;
      }
      // Luhn算法校验
      let sum = 0;
      let isEven = false;
      // 从右向左遍历
      for (let i = cardNo.length - 1; i >= 0; i--) {
        let digit = parseInt(cardNo[i]);
        if (isEven) {
          digit *= 2;
          if (digit > 9) {
            digit -= 9;
          }
        }
        sum += digit;
        isEven = !isEven;
      }
      return sum % 10 === 0;
    };
    // 修改表单验证规则
    const withdrawRules = reactive({
      withdrawAmount: [{
        required: true,
        message: '请输入提现金额',
        trigger: 'blur'
      }, {
        type: 'number',
        min: MIN_WITHDRAW_AMOUNT.value,
        max: MAX_WITHDRAW_AMOUNT,
        message: `单笔提现金额需在${MIN_WITHDRAW_AMOUNT.value}元-${MAX_WITHDRAW_AMOUNT}元范围内`,
        trigger: 'blur'
      }],
      paymentType: [{
        required: true,
        message: '请选择提现方式',
        trigger: 'change'
      }],
      openid: [{
        required: true,
        message: '请绑定微信',
        trigger: 'blur'
      }],
      bankNo: [{
        required: true,
        message: '请输入银行卡号',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          if (!value) {
            callback();
            return;
          }
          if (!validateBankCard(value)) {
            callback(new Error('请输入正确的银行卡号'));
            return;
          }
          callback();
        },
        trigger: 'blur'
      }],
      bankName: [{
        required: true,
        message: '请输入开户银行',
        trigger: 'blur'
      }],
      realName: [{
        required: true,
        message: '请输入真实姓名',
        trigger: 'blur'
      }, {
        pattern: /^[\u4e00-\u9fa5]+$/,
        message: '请输入中文姓名',
        trigger: 'blur'
      }]
    });
    // 显示提现弹窗
    const showWithdrawDialog = () => {
      withdrawDialogVisible.value = true;
      // 设置用户名
      if (commissionData.value) {
        withdrawForm.value.memberUsername = commissionData.value.memberUsername;
      }
    };
    // 提交提现申请
    const submitWithdraw = async () => {
      if (!withdrawFormRef.value) return;
      await withdrawFormRef.value.validate((valid, fields) => {
        if (valid) {
          // 这里添加提现API调用
          console.log('提交提现申请', withdrawForm.value);
          distAddWithdraw(withdrawForm.value).then(res => {
            let {
              code,
              data,
              msg
            } = res.data;
            if (code === 200) {
              ElMessage.success('提现申请已提交');
              getMemberInfoFn();
              withdrawDialogVisible.value = false;
            }
          }).catch(err => {
            console.error('err', err);
          });
        } else {
          ElMessage.warning('操作失败');
        }
      });
    };
    const addUserDialogVisible = ref(false);
    const addUserFormRef = ref();
    const addUserForm = ref({
      userId: ''
    });
    const addUserRules = reactive({
      userId: [{
        required: true,
        message: '请输入用户ID',
        trigger: 'blur'
      }]
    });
    const showAddUserDialog = () => {
      addUserDialogVisible.value = true;
    };
    const submitAddUser = async () => {
      if (!addUserFormRef.value) return;
      await addUserFormRef.value.validate((valid, fields) => {
        if (valid) {
          // 这里添加API调用
          console.log('添加分佣用户', addUserForm.value);
          distAddMember(addUserForm.value).then(rest => {
            let {
              code,
              data
            } = res.data;
            if (code == 200) {
              ElMessage.success('添加成功');
              addUserDialogVisible.value = false;
            }
          }).catch(err => {
            console.error('err', err);
          });
        }
      });
    };
    return (_ctx, _cache) => {
      var _commissionData$value, _commissionData$value5, _commissionData$value6, _commissionData$value7, _commissionData$value8;
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "title"
      }, "可提现金额", -1)), _createElementVNode("div", _hoisted_5, "¥ " + _toDisplayString(((_commissionData$value = commissionData.value) === null || _commissionData$value === void 0 || (_commissionData$value = _commissionData$value.summary) === null || _commissionData$value === void 0 ? void 0 : _commissionData$value.allAvailableWithdraw) || '0'), 1), _createVNode(_component_el_button, {
        type: "primary",
        class: "withdraw-btn",
        onClick: _cache[0] || (_cache[0] = $event => {
          var _commissionData$value2;
          return ((_commissionData$value2 = commissionData.value) === null || _commissionData$value2 === void 0 || (_commissionData$value2 = _commissionData$value2.summary) === null || _commissionData$value2 === void 0 ? void 0 : _commissionData$value2.allProfitMoney) > 0 ? showWithdrawDialog() : _unref(getRegisterInviteCreateInvite)();
        })
      }, {
        default: _withCtx(() => {
          var _commissionData$value3, _commissionData$value4;
          return [_createElementVNode("i", {
            class: _normalizeClass(((_commissionData$value3 = commissionData.value) === null || _commissionData$value3 === void 0 || (_commissionData$value3 = _commissionData$value3.summary) === null || _commissionData$value3 === void 0 ? void 0 : _commissionData$value3.allProfitMoney) > 0 ? 'ri-wallet-3-line' : 'ri-links-line')
          }, null, 2), _createTextVNode(" " + _toDisplayString(((_commissionData$value4 = commissionData.value) === null || _commissionData$value4 === void 0 || (_commissionData$value4 = _commissionData$value4.summary) === null || _commissionData$value4 === void 0 ? void 0 : _commissionData$value4.allProfitMoney) > 0 ? '我要去提现' : '我要去赚米'), 1)];
        }),
        _: 1
      })]), _cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "card-decoration"
      }, [_createElementVNode("i", {
        class: "ri-money-dollar-circle-line decoration-icon"
      }), _createElementVNode("i", {
        class: "ri-coin-line decoration-icon"
      })], -1))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[20] || (_cache[20] = _createElementVNode("i", {
        class: "ri-money-dollar-circle-fill"
      }, null, -1)), _cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "label"
      }, "累计总金额", -1)), _createElementVNode("div", _hoisted_8, "¥" + _toDisplayString(((_commissionData$value5 = commissionData.value) === null || _commissionData$value5 === void 0 || (_commissionData$value5 = _commissionData$value5.summary) === null || _commissionData$value5 === void 0 ? void 0 : _commissionData$value5.allProfitMoney) || '0'), 1)]), _createElementVNode("div", _hoisted_9, [_cache[22] || (_cache[22] = _createElementVNode("i", {
        class: "ri-line-chart-line"
      }, null, -1)), _cache[23] || (_cache[23] = _createElementVNode("div", {
        class: "label"
      }, "今日交易额", -1)), _createElementVNode("div", _hoisted_10, "¥" + _toDisplayString(((_commissionData$value6 = commissionData.value) === null || _commissionData$value6 === void 0 || (_commissionData$value6 = _commissionData$value6.today) === null || _commissionData$value6 === void 0 ? void 0 : _commissionData$value6.tradeMoney) || '0'), 1)]), _createElementVNode("div", _hoisted_11, [_cache[24] || (_cache[24] = _createElementVNode("i", {
        class: "ri-wallet-3-line"
      }, null, -1)), _cache[25] || (_cache[25] = _createElementVNode("div", {
        class: "label"
      }, "今日返利", -1)), _createElementVNode("div", _hoisted_12, "¥" + _toDisplayString(((_commissionData$value7 = commissionData.value) === null || _commissionData$value7 === void 0 || (_commissionData$value7 = _commissionData$value7.today) === null || _commissionData$value7 === void 0 ? void 0 : _commissionData$value7.profitMoney) || '0'), 1)]), _createElementVNode("div", _hoisted_13, [_cache[26] || (_cache[26] = _createElementVNode("i", {
        class: "ri-group-2-line"
      }, null, -1)), _cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "label"
      }, "团队人数", -1)), _createElementVNode("div", _hoisted_14, _toDisplayString(((_commissionData$value8 = commissionData.value) === null || _commissionData$value8 === void 0 || (_commissionData$value8 = _commissionData$value8.summary) === null || _commissionData$value8 === void 0 ? void 0 : _commissionData$value8.allTeamCount) || '0') + "人", 1)])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[29] || (_cache[29] = _createElementVNode("div", {
        class: "title-left"
      }, [_createElementVNode("i", {
        class: "ri-information-line"
      }), _createTextVNode(" 邀请与返利说明 ")], -1)), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        style: {
          "height": "30px"
        },
        onClick: _unref(getRegisterInviteCreateInvite)
      }, {
        default: _withCtx(() => _cache[28] || (_cache[28] = [_createElementVNode("i", {
          class: "ri-links-line",
          style: {
            "color": "#fff"
          }
        }, null, -1), _createTextVNode(" 获取邀请链接 ")])),
        _: 1
      }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_18, [_cache[30] || (_cache[30] = _createElementVNode("p", null, "1. 邀请好友注册成功即可获得返利", -1)), _cache[31] || (_cache[31] = _createElementVNode("p", null, "2. 返利金额将在好友完成首次消费后到账", -1)), _createElementVNode("p", null, "3. 累计返利满" + _toDisplayString(MIN_WITHDRAW_AMOUNT.value) + "元即可提现", 1), _cache[32] || (_cache[32] = _createElementVNode("p", null, "4. 客服热线：18666356083", -1))])]), _createElementVNode("div", _hoisted_19, [_cache[33] || (_cache[33] = _createElementVNode("div", {
        class: "card-title"
      }, [_createElementVNode("i", {
        class: "ri-file-list-3-line"
      }), _createTextVNode(" 返利记录 ")], -1)), _createVNode(_component_el_table, {
        data: commissionList.value,
        style: {
          "width": "100%"
        },
        height: "400",
        stripe: true,
        border: "",
        "header-cell-style": {
          background: '#f6f8fb',
          color: '#606266',
          fontWeight: 600,
          fontSize: '14px',
          height: '50px'
        },
        "cell-style": {
          fontSize: '14px',
          padding: '12px 0'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "时间",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "eventNumber",
          label: "订单号",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "eventPrice",
          label: "交易金额",
          align: "right"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", _hoisted_20, "¥" + _toDisplayString(scope.row.eventPrice), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "incomeAmount",
          label: "佣金金额",
          align: "right"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", _hoisted_21, "¥" + _toDisplayString(scope.row.incomeAmount), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "triggerMemberUsername",
          label: "触发用户"
        }), _createVNode(_component_el_table_column, {
          prop: "profitTypeMessage",
          label: "类型"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            size: "small",
            effect: "dark",
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.profitTypeMessage), 1)]),
            _: 2
          }, 1024)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_pagination, {
        "current-page": currentPage1.value,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => currentPage1.value = $event),
        "page-size": pageSize1.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => pageSize1.value = $event),
        total: total1.value,
        "page-sizes": [10, 20, 30, 50],
        layout: "total, sizes, prev, pager, next, jumper",
        onSizeChange: handleSizeChange1,
        onCurrentChange: handleCurrentChange1
      }, null, 8, ["current-page", "page-size", "total"])])]), _createElementVNode("div", _hoisted_23, [_cache[34] || (_cache[34] = _createElementVNode("div", {
        class: "card-title"
      }, [_createElementVNode("i", {
        class: "ri-money-cny-box-line"
      }), _createTextVNode(" 提现记录 ")], -1)), _createVNode(_component_el_table, {
        data: withdrawList.value,
        style: {
          "width": "100%"
        },
        height: "400",
        stripe: true,
        border: "",
        "header-cell-style": {
          background: '#f6f8fb',
          color: '#606266',
          fontWeight: 600,
          fontSize: '14px',
          height: '50px'
        },
        "cell-style": {
          fontSize: '14px',
          padding: '12px 0'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "申请时间",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "withdrawNumber",
          label: "提现单号",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "withdrawAmount",
          label: "提现金额",
          align: "right"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", _hoisted_24, "¥" + _toDisplayString(scope.row.withdrawAmount), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "feeAmount",
          label: "手续费",
          align: "right"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", _hoisted_25, "¥" + _toDisplayString(scope.row.feeAmount), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "bankName",
          label: "提现银行"
        }), _createVNode(_component_el_table_column, {
          prop: "disposeStateMessage",
          label: "状态"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            size: "small",
            effect: "dark",
            type: scope.row.disposeState === 'WAIT_AUDIT' ? 'warning' : 'success'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.disposeStateMessage), 1)]),
            _: 2
          }, 1032, ["type"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_pagination, {
        "current-page": currentPage2.value,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => currentPage2.value = $event),
        "page-size": pageSize2.value,
        "onUpdate:pageSize": _cache[4] || (_cache[4] = $event => pageSize2.value = $event),
        total: total2.value,
        "page-sizes": [10, 20, 30, 50],
        layout: "total, sizes, prev, pager, next, jumper",
        onSizeChange: handleSizeChange2,
        onCurrentChange: handleCurrentChange2
      }, null, 8, ["current-page", "page-size", "total"])])]), _createVNode(_component_el_dialog, {
        modelValue: _unref(inviteShow),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(inviteShow) ? inviteShow.value = $event : inviteShow = $event),
        class: "invite-dialog"
      }, {
        default: _withCtx(() => [_createVNode(inviteCard, {
          dashboardLink: _unref(inviteData).inviteUrl,
          imgSrc: _unref(inviteData).qrCode,
          overTime: _unref(inviteData).overTime
        }, null, 8, ["dashboardLink", "imgSrc", "overTime"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: withdrawDialogVisible.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => withdrawDialogVisible.value = $event),
        title: "提现申请",
        width: "500px",
        class: "withdraw-dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_28, [_createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = $event => withdrawDialogVisible.value = false),
          plain: ""
        }, {
          default: _withCtx(() => _cache[39] || (_cache[39] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitWithdraw
        }, {
          default: _withCtx(() => _cache[40] || (_cache[40] = [_createElementVNode("i", {
            class: "ri-check-line"
          }, null, -1), _createTextVNode("确认提现 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: withdrawForm.value,
          rules: withdrawRules,
          ref_key: "withdrawFormRef",
          ref: withdrawFormRef,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "提现金额",
            prop: "withdrawAmount"
          }, {
            default: _withCtx(() => {
              var _commissionData$value9;
              return [_createVNode(_component_el_input, {
                modelValue: withdrawForm.value.withdrawAmount,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => withdrawForm.value.withdrawAmount = $event),
                modelModifiers: {
                  number: true
                },
                type: "number",
                placeholder: "请输入提现金额"
              }, {
                prefix: _withCtx(() => _cache[35] || (_cache[35] = [_createTextVNode("¥")])),
                _: 1
              }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_27, "可提现金额: ¥" + _toDisplayString(((_commissionData$value9 = commissionData.value) === null || _commissionData$value9 === void 0 || (_commissionData$value9 = _commissionData$value9.summary) === null || _commissionData$value9 === void 0 ? void 0 : _commissionData$value9.allAvailableWithdraw) || 0), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "提现方式",
            prop: "paymentType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: withdrawForm.value.paymentType,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => withdrawForm.value.paymentType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: "WE_CHAT"
              }, {
                default: _withCtx(() => _cache[36] || (_cache[36] = [_createElementVNode("i", {
                  class: "ri-wechat-pay-fill"
                }, null, -1), _createTextVNode(" 微信提现 ")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: "BANK"
              }, {
                default: _withCtx(() => _cache[37] || (_cache[37] = [_createElementVNode("i", {
                  class: "ri-bank-card-fill"
                }, null, -1), _createTextVNode(" 银行卡提现 ")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), withdrawForm.value.paymentType === 'WE_CHAT' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "微信openid",
            prop: "openid"
          }, {
            default: _withCtx(() => [_unref(userInfo).openid ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: withdrawForm.value.openid,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => withdrawForm.value.openid = $event),
              disabled: "",
              placeholder: "请输入微信openid"
            }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              size: "small",
              onClick: _unref(bindWeChat)
            }, {
              default: _withCtx(() => _cache[38] || (_cache[38] = [_createTextVNode("尚未绑定微信无法提现")])),
              _: 1
            }, 8, ["onClick"]))]),
            _: 1
          })) : _createCommentVNode("", true), withdrawForm.value.paymentType === 'BANK' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_form_item, {
            label: "银行卡号",
            prop: "bankNo"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: withdrawForm.value.bankNo,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => withdrawForm.value.bankNo = $event),
              placeholder: "请输入银行卡号"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "开户银行",
            prop: "bankName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: withdrawForm.value.bankName,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => withdrawForm.value.bankName = $event),
              placeholder: "请选择开户银行"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankOptions.value, bank => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: bank.value,
                  label: bank.name,
                  value: bank.name
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "支行名称",
            prop: "bankBranchName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: withdrawForm.value.bankBranchName,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => withdrawForm.value.bankBranchName = $event),
              placeholder: "请输入支行名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "真实姓名",
            prop: "realName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: withdrawForm.value.realName,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => withdrawForm.value.realName = $event),
              placeholder: "请输入真实姓名"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: addUserDialogVisible.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => addUserDialogVisible.value = $event),
        title: "添加分佣用户",
        width: "400px",
        class: "add-user-dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_29, [_createVNode(_component_el_button, {
          onClick: _cache[16] || (_cache[16] = $event => addUserDialogVisible.value = false),
          plain: ""
        }, {
          default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitAddUser
        }, {
          default: _withCtx(() => _cache[44] || (_cache[44] = [_createElementVNode("i", {
            class: "ri-check-line"
          }, null, -1), _createTextVNode("确认添加 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: addUserForm.value,
          rules: addUserRules,
          ref_key: "addUserFormRef",
          ref: addUserFormRef,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户ID",
            prop: "userId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: addUserForm.value.userId,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => addUserForm.value.userId = $event),
              placeholder: "请输入用户ID"
            }, {
              prefix: _withCtx(() => _cache[41] || (_cache[41] = [_createElementVNode("i", {
                class: "ri-user-line"
              }, null, -1)])),
              _: 1
            }, 8, ["modelValue"]), _cache[42] || (_cache[42] = _createElementVNode("div", {
              class: "user-id-tip"
            }, "请输入需要添加为分佣用户的用户ID", -1))]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});